const initialState = {
  attendance: [],
  monthly_summary: [],
  attendance_status: null,
  employee: null,
  error: null,
  isLoding: false
};

const AttendanceApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LODING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_ATTENDANCE_SUCCESS":
      return {
        ...state,
        attendance: action.payload,
        error: null
      };
    case "GET_ATTENDANCE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_EMPLOYEE_SUCCESS":
      return {
        ...state,
        employee: action.payload,
        error: null
      };
    case "GET_EMPLOYEE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };


    case "ADD_ATTENDANCE_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_ATTENDANCE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    case "UPDATE_ATTENDANCE_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_ATTENDANCE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_MONTHLY_ATTENDANCE_SUCCESS":
      return {
        ...state,
        monthly_summary: action.payload,
        error: null
      };
    case "GET_MONTHLY_ATTENDANCE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_LAST_ATTENDANCE_SUCCESS":
      return {
        ...state,
        attendance_status: action.payload,
        error: null
      };
    case "GET_LAST_ATTENDANCE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GENRATE_ATTENDANCE_REPORT_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "GENRATE_ATTENDANCE_REPORT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    default:
      return state;
  }
};

export default AttendanceApiReducer;
